import { render, staticRenderFns } from "./sessionsList.vue?vue&type=template&id=42670af0&"
import script from "./sessionsList.vue?vue&type=script&lang=js&"
export * from "./sessionsList.vue?vue&type=script&lang=js&"
import style0 from "./sessionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports